import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/groups/{slug}/students/quiz-submissions/` redirects to `quizzes`, as legacy
 * does. `trailingSlash: 'always'` folds both spellings onto this route.
 *
 * Done in `beforeLoad`, since no data is needed, so the empty tab body never
 * paints.
 */
export const Route = createFileRoute(
  '/_app/_dashboard/groups/$groupName/students/quiz-submissions/',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/groups/$groupName/students/quiz-submissions/quizzes/',
      params: { groupName: params.groupName },
      replace: true,
    });
  },
});
